import { HttpParameterCodec, HttpParams } from '@angular/common/http';
export class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

/** Join id arrays into one comma-separated search param (Hub / Spring List convention). */
export function joinSearchIds(
  ids: Array<string | null | undefined> | null | undefined
): string {
  return (ids || [])
    .map((id) => (typeof id === 'string' ? id.trim() : id))
    .filter((id): id is string => !!id)
    .join(',');
}

export function encodeParams(params: any) {
  let httpParams = new HttpParams({ encoder: new CustomHttpParamEncoder() });
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value == null || value === '') {
      return;
    }
    // Repeated keys. Callers that need a multi-id filter must join first
    // (joinSearchIds); some *Id params are a singular String on the API.
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item == null || item === '') {
          return;
        }
        const encodedItem =
          typeof item === 'string' ? item.trim() : String(item);
        httpParams = httpParams.append(key, encodedItem);
      });
      return;
    }
    //This will trim any leading/ending spaces on inputs
    if (typeof value === 'string') {
      httpParams = httpParams.set(key, value.trim());
      return;
    }
    httpParams = httpParams.set(key, value);
  });
  return httpParams;
}

export function removeEmptyParams(searchParams: any) {
  Object.keys(searchParams).forEach((key) => {
    if (searchParams[key] == null || searchParams[key].toString() == '') {
      delete searchParams[key];
    }
  });
  return searchParams;
}
